import john from './../assets/john.jpg'
import tom from './../assets/tom.jpg'
import Xmen from './../assets/xx.jpg'
import spider from './../assets/spider.jpg'
export const FeedbackData = [

    {
       id: 1,
       Name: "Sourav ",
       Company: "Abc company",
       Comment:"“From they fine john he give of rich he. They age and draw mrs like. Improving end distrusts may instantly was household applauded incommode. Why kept very ever home mrs. Considered sympathize ten uncommonly occasional assistance sufficient not.”",
       Image: john,
    },
    {
        id: 2,
        Name: "Rohan",
        Company: "Abc company",
       Comment:"“From they fine john he give of rich he. They age and draw mrs like. Improving end distrusts may instantly was household applauded incommode. Why kept very ever home mrs. Considered sympathize ten uncommonly occasional assistance sufficient not.”",
       Image: tom,
     },
     {
        id: 3,
        Name: "Rejowan",
         Company: "Abc company",
       Comment:"“From they fine john he give of rich he. They age and draw mrs like. Improving end distrusts may instantly was household applauded incommode. Why kept very ever home mrs. Considered sympathize ten uncommonly occasional assistance sufficient not.”",
       Image: Xmen,
     },
     {
        id: 4,
        Name: "Siam",
        Company: "Abc company",
       Comment:"“From they fine john he give of rich he. They age and draw mrs like. Improving end distrusts may instantly was household applauded incommode. Why kept very ever home mrs. Considered sympathize ten uncommonly occasional assistance sufficient not.”",
       Image:spider,
     }
]